import script from "./GabinetePessoaFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./GabinetePessoaFrame.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/layoutFrames.css?vue&type=style&index=0&id=0fe52c5c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe52c5c"]])

export default __exports__